import SEAT_CHARACTERISTICS from '../../scripts/constants/seat-characteristics-enum';
import CurrencyValueUIModel from './currency-value';

class SeatChoiceUIModel {
  constructor({
    code,
    currency,
    farelogixDesignator,
    farelogixPrice,
    productName,
    seatCharacteristics,
    subjectToSeatSelectionFee,
    type,
  }) {
    this.code = code;
    this.currency = currency ? new CurrencyValueUIModel(currency) : null;
    this.farelogixDesignator = farelogixDesignator;
    this.farelogixPrice = farelogixPrice;
    this.isAisleSeat = (seatCharacteristics || []).indexOf(SEAT_CHARACTERISTICS.A) > -1;
    this.isExitRowSeat = (seatCharacteristics || []).indexOf(SEAT_CHARACTERISTICS.EXIT_ROW) > -1;
    this.isMiddleSeat = (seatCharacteristics || []).indexOf(SEAT_CHARACTERISTICS.M) > -1;
    this.isNonRecliningSeat = (seatCharacteristics || []).indexOf(SEAT_CHARACTERISTICS.DO_NOT_RECLINE) > -1;
    this.isWindowNoWindow =  (seatCharacteristics || []).indexOf(SEAT_CHARACTERISTICS.XW) > -1;
    this.isWindowSeat = (seatCharacteristics || []).indexOf(SEAT_CHARACTERISTICS.W) > -1;
    this.seatCharacteristics = seatCharacteristics || [];
    this.subjectToSeatSelectionFee = subjectToSeatSelectionFee;
    this.type = type ? type : productName;
  }

  getSeatLabel() {
    const {
      isAisleSeat,
      isWindowSeat,
      isMiddleSeat,
      isExitRowSeat,
    } = this;

    let labelCopyID = '';

    if (isWindowSeat) {
      labelCopyID = 'WINDOW_SEAT';
    } else if (isAisleSeat) {
      labelCopyID = 'AISLE_SEAT';
    } else if (isMiddleSeat) {
      labelCopyID = 'MIDDLE_SEAT';
    } else if (isExitRowSeat) {
      labelCopyID = 'EXIT_ROW_SEAT';
    } else {
      labelCopyID = 'SEAT';
    }

    return labelCopyID;
  }

  getSeatLabelSeatMap() {
    const {
      isAisleSeat,
      isWindowSeat,
      isMiddleSeat,
    } = this;

    let labelCopyID = '';

    if (isWindowSeat) {
      labelCopyID = 'SEATMAP_SEAT_TYPE_WINDOW';
    } else if (isAisleSeat) {
      labelCopyID = 'SEATMAP_SEAT_TYPE_AISLE';
    } else if (isMiddleSeat) {
      labelCopyID = 'SEATMAP_SEAT_TYPE_MIDDLE';
    }
    return labelCopyID;
  }

  getFormatCode() {
    const codeLength = this.code.length;
    let numberSeat = '';
    const letterSeat = this.code.substring(codeLength - 1);

    if ( codeLength > 2 ) {
      numberSeat = this.code.substring(0, 2);
    } else {
      numberSeat = this.code.substring(0, 1);
    }

    const formatSeat = numberSeat + ' ' + letterSeat;
    return formatSeat;
  }

  getSeatLabelByType() {
    let labelId = 'SEATMAP_REGULAR_SEATING';
    switch (this.type) {
      case 'EXIT_ROW_UPGRADE':
        labelId = 'EXIT_ROW_SEAT';
        break;
      case 'PREFERRED_UPGRADE':
        labelId = 'PREFERRED';
        break;
      case 'AMPLUS_UPGRADE':
        labelId = 'AM_PLUS';
        break;
      default:
        labelId = 'SEATMAP_REGULAR_SEATING';
        break;
    }
    return labelId;
  }

  getTotal() {
    return this.currency ? this.currency.getTotal() : null;
  }

  getTotalPoints() {
    return this.currency ? this.currency.getTotalPoints() : null;
  }

  getTotalTax() {
    let totalTax = this.currency ? this.currency.getTotalTax() : null;
    if (totalTax !== null) {
      if (totalTax === 0) {
        const taxDetails = this.getTaxDetails;
        if (taxDetails) {
          Object.keys(taxDetails).forEach(nameTax => {
            totalTax += taxDetails[nameTax];
          });
        }
      }
    }
    return totalTax;
  }

  getTaxDetails() {
    return this.currency ? this.currency.getTaxDetails() : null;
  }

  toApi() {
    return {
      '_meta':{
        'class': this.currency ? 'SeatChoiceUpsell' : 'SeatChoice',
      },
      'code': this.code,
      'currency': this.currency ? this.currency.toAPI() : this.currency,
      'farelogixDesignator': this.farelogixDesignator,
      'farelogixPrice': this.farelogixPrice,
      'points': null,
      'seatCharacteristics': this.seatCharacteristics,
      'subjectToSeatSelectionFee': this.subjectToSeatSelectionFee,
      'type': this.type,
    };
  }
}

export default SeatChoiceUIModel;
